




































import mixins from 'vue-typed-mixins'
import AbstractScriptRowVersion from '../abstract'

export default mixins(AbstractScriptRowVersion).extend({})
